export default "__VITE_ASSET__DHUoVojK__"